<!-- Modal Header -->
<div class="modal-header modal-head">
  <div class="modal-titles">
    CARICAMENTO ORARI STORE CUSTOM
    <br>
    <sub>
      {{infoStoreTitle}}
    </sub>
  </div>
</div>

<!-- Modal body -->
<div class="modal-body mx-4">
  <app-openingclosinghours-table [inputOpeningclosinghoursTable]="inputOpeningclosinghoursTable" [hasOriginalOpeningclosinghours]="hasOriginalOpeningclosinghours"
    (outputOpeningclosinghoursTable)="changeTableHours($event)">
  </app-openingclosinghours-table>
  <!--Buttons-->
  <div class="my-3 text-center">
    <button type="button" class="btn btn-fw text me-3" (click)="saveOpeningclosinghours()"
      [disabled]="!isValidOpeningclosinghours">Salva modifiche</button>
    <button type="button" class="btn btn-outline-fw text" (click)="cancel()">Annulla</button>
  </div>


  <!--Aperture straordinarie-->
  <div class="row align-middle align-items-center">
    <div class="col-3 card-title my-0">Aperture straordinarie</div>
    <div class="col-3 text fw-normal size-16 text-decoration-underline">
      <span class="collapsed clickable" data-bs-toggle="collapse" data-bs-target="#archiveSpecialOpeningHours"
        aria-expanded="false" aria-controls="archiveSpecialOpeningHours">
        Archivio
      </span>
      
    </div>
    <div class="col-3"></div>
    <div class="col-3 d-flex justify-content-end">
      <button type="button" class="btn btn-fw text" (click)="saveSpecialOpeninghours()"
        [disabled]="!isValidSpecialOpeninghours">Aggiungi nuova</button>
    </div>
  </div>

  <app-specialopeninghours [inputSpecialOpeningHours]="inputSpecialOpeningHours"
    (outputSpecialOpeningHours)=changeSpecialOpeningHours($event)></app-specialopeninghours>

  <div id="archiveSpecialOpeningHours" class="accordion-collapse collapse" aria-labelledby="headingOne"
    data-bs-parent="#accordionExample">
    <div class="accordion-body">
      <div *ngFor="let obj of pastSpecialOpenighours">
        <div class="row align-middle align-items-center mt-2">
          <div class="col-2">
            {{obj.date}}
          </div>
          <div class="col-3 d-inline-flex align-items-center">
            <div class="col ">
              <span>Dalle:</span>
              {{obj.mFrom}}
            </div>
            <div class="col align-items-center">
              <span class="ms-2">Alle:</span>
              {{obj.mTo}}
            </div>
          </div>
          <div class="col-3 d-inline-flex">
            <div class="col align-items-center">
              <span>Dalle:</span>
              {{obj.eFrom}}
            </div>
            <div class="col align-items-center">
              <span class="ms-2">Alle:</span>
              {{obj.eTo}}
            </div>
          </div>
          <div class="col-3">
            <div class="col">
              {{obj.note}}
            </div>
          </div>
          <div class="col-1">
            <a [hidden]="!obj.isVisibleDelete" class="btn btn-lg" (click)="clickButtonDeleteSpecialOpeninghours(obj.id)"><i
                class="far fa-trash-alt red"></i></a>
          </div>
        </div>
      </div>
      <div class="row align-middle" *ngIf="pastSpecialOpenighours.length==0">
        <div class="col text-center">
          Nessuna apertura straordinaria in archivio
        </div>
      </div>
    </div>
  </div>
  <div aria-labelledby="headingOne"
  data-bs-parent="#accordionExample">
  <div class="accordion-body">
    <div *ngFor="let obj of futureSpecialOpenighours">
      <div class="row align-middle align-items-center mt-2">
        <div class="col-2">
          {{obj.date}}
        </div>
        <div class="col-3 d-inline-flex align-items-center">
          <div class="col ">
            <span>Dalle:</span>
            {{obj.mFrom}}
          </div>
          <div class="col align-items-center">
            <span class="ms-2">Alle:</span>
            {{obj.mTo}}
          </div>
        </div>
        <div class="col-3 d-inline-flex">
          <div class="col align-items-center">
            <span>Dalle:</span>
            {{obj.eFrom}}
          </div>
          <div class="col align-items-center">
            <span class="ms-2">Alle:</span>
            {{obj.eTo}}
          </div>
        </div>
        <div class="col-3">
          <div class="col">
            {{obj.note}}
          </div>
        </div>
        <div class="col-1">
          <a [hidden]="!obj.isVisibleDelete" class="btn btn-lg" (click)="clickButtonDeleteSpecialOpeninghours(obj.id)"><i
              class="far fa-trash-alt red"></i></a>
        </div>
      </div>
    </div>
    <div class="row align-middle" *ngIf="futureSpecialOpenighours.length==0">
      <div class="col text-center">
        Nessuna apertura straordinaria
      </div>
    </div>
  </div>
</div>


  <!--Chiusure straordinarie-->
  <div class="row align-middle align-items-center mt-4">
    <div class="col-3 card-title my-0">Chiusure straordinarie</div>
    <div class="col-3 text fw-normal size-16 text-decoration-underline">
      <span class="collapsed clickable" data-bs-toggle="collapse" data-bs-target="#archiveSpecialClosingHours"
        aria-expanded="false" aria-controls="archiveSpecialClosingHours">
        Archivio
      </span>
    </div>
    <div class="col-3"></div>
    <div class="col-3 d-flex justify-content-end">
      <button type="button" class="btn btn-fw text" (click)="saveSpecialClosinghours()"
        [disabled]="!isValidSpecialClosinghours">Aggiungi nuova</button>
    </div>
  </div>

  <app-specialclosinghours [inputSpecialClosingHours]="inputSpecialClosingHours"
    (outputSpecialClosingHours)="changeSpecialClosingHours($event)"></app-specialclosinghours>

  <div id="archiveSpecialClosingHours" class="accordion-collapse collapse" aria-labelledby="headingOne"
    data-bs-parent="#accordionExample">
    <div class="accordion-body">
      <div *ngFor="let obj of pastSpecialClosinghours">
        <div class="row align-middle align-items-center mt-2">
          <div class="col-2">
            {{obj.date}}
          </div>
          <div class="col-3 d-inline-flex align-items-center">
            <div class="col ">
              <span>Dalle:</span>
              {{obj.mFrom}}
            </div>
            <div class="col align-items-center">
              <span class="ms-2">Alle:</span>
              {{obj.mTo}}
            </div>
          </div>
          <div class="col-3 d-inline-flex">
            <div class="col align-items-center">
              <span>Dalle:</span>
              {{obj.eFrom}}
            </div>
            <div class="col align-items-center">
              <span class="ms-2">Alle:</span>
              {{obj.eTo}}
            </div>
          </div>
          <div class="col-3">
            <div class="col">
              {{obj.note}}
            </div>
          </div>
          <div class="col-1">
            <a [hidden]="!obj.isVisibleDelete" class="btn btn-lg" (click)="clickButtonDeleteSpecialClosinghours(obj.id)"><i
                class="far fa-trash-alt red"></i></a>
          </div>
        </div>
      </div>
      <div class="row align-middle" *ngIf="pastSpecialClosinghours.length==0">
        <div class="col text-center">
          Nessuna chiusura straordinaria in archivio
        </div>
      </div>
    </div>
  </div>

  <div aria-labelledby="headingOne"
  data-bs-parent="#accordionExample">
  <div class="accordion-body">
    <div *ngFor="let obj of futureSpecialClosinghours">
      <div class="row align-middle align-items-center mt-2">
        <div class="col-2">
          {{obj.date}}
        </div>
        <div class="col-3 d-inline-flex align-items-center">
          <div class="col ">
            <span>Dalle:</span>
            {{obj.mFrom}}
          </div>
          <div class="col align-items-center">
            <span class="ms-2">Alle:</span>
            {{obj.mTo}}
          </div>
        </div>
        <div class="col-3 d-inline-flex">
          <div class="col align-items-center">
            <span>Dalle:</span>
            {{obj.eFrom}}
          </div>
          <div class="col align-items-center">
            <span class="ms-2">Alle:</span>
            {{obj.eTo}}
          </div>
        </div>
        <div class="col-3">
          <div class="col">
            {{obj.note}}
          </div>
        </div>
        <div class="col-1">
          <a [hidden]="!obj.isVisibleDelete" class="btn btn-lg" (click)="clickButtonDeleteSpecialClosinghours(obj.id)"><i
              class="far fa-trash-alt red"></i></a>
        </div>
      </div>
    </div>
    <div class="row align-middle" *ngIf="futureSpecialClosinghours ==0">
      <div class="col text-center">
        Nessuna chiusura straordinaria
      </div>
    </div>
  </div>
</div>



</div>